import send from "./modules/send";
import validate from "./modules/validate";
window.addEventListener("load", () => {
    SmoothScroll({
        // Время скролла 400 = 0.4 секунды
        animationTime: 700,
        // Размер шага в пикселях
        stepSize: 80,
    
        // Дополнительные настройки:
    
        // Ускорение
        accelerationDelta: 20,
        // Максимальное ускорение
        accelerationMax: 1,
    
        // Поддержка клавиатуры
        keyboardSupport: true,
        // Шаг скролла стрелками на клавиатуре в пикселях
        arrowScroll: 50,
    
        // Pulse (less tweakable)
        // ratio of "tail" to "acceleration"
        pulseAlgorithm: true,
        pulseScale: 4,
        pulseNormalize: 1,
    
        // Поддержка тачпада
        touchpadSupport: true,
      });
 
    gsap.to('.preloader', {
        duration: 1,
        autoAlpha: 0,
        onComplete: () => {
        }
    })

    const drop = document.querySelector('.form__drop');
    const dropValue = document.querySelector('.form__drop>span');
    const dropInput = document.querySelector('.form__drop>input');
    const spanValues = document.querySelectorAll('.form__wrap>span');
    const dropContainer = document.querySelector('.form__wrap');

    let toggleBlock = gsap.to(dropContainer, {
        height: 'auto',
        paused: true,
        autoAlpha: 1,
        duration: .3,
        ease: 'power1.out'
    })

    drop.addEventListener('click', () => {
        drop.classList.toggle('selected');
        dropContainer.classList.toggle('open');
        dropContainer.classList.toggle('show');
        dropContainer.classList.contains('show') ? toggleBlock.play() : toggleBlock.reverse();
    })

    spanValues.forEach(item => {

        item.addEventListener('click', () => {
            dropValue.textContent = item.textContent;
            drop.classList.add('check')
            dropInput.value = item.textContent;
        })
    })

    validate('input[name="name1"]', 'input[name="phone1"]', 'input[name="email1"]');
    send('#brief', 'input[name="name1"]', 'input[name="phone1"]', 'input[name="email1"]', "/mailer/mail.php")

})